import Create from './Create';
import appRoles from '../../util/roles';

const roles = [
    appRoles.SysAdmin,
];

const name = 'districtcourses';

export default { name, roles, Create };